import { ADMIN_EMAIL_KEY, ADMIN_USER_ID_KEY } from "@/utils/constants";
import { removeToken } from "@/utils/token";
import Cookies from "js-cookie";

/**
 * Clears the auth session: removes tokens (and their Axios auth headers) plus
 * the identity cookies. Call this before starting a fresh session or when the
 * current session becomes invalid.
 */
export const logout = () => {
  removeToken();
  Cookies.remove(ADMIN_USER_ID_KEY);
  Cookies.remove(ADMIN_EMAIL_KEY);
};
